import { format, subDays } from "date-fns";

export function isPlainObject(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
}

export function isInteger(value) {
  return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}

export function upperFirst(value) {
  value = String(value);

  if (!value.length) {
    return value;
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function cloneDeep(data) {
  return JSON.parse(JSON.stringify(data));
}

export function getPercentage(value, total, digits) {
  if (isNaN(value) || isNaN(total) || total === 0) {
    return 0;
  }

  let result = (value / total) * 100;

  if (digits !== undefined) {
    result = Number(result.toFixed(digits));
  }
  return result;
}

export function getTimeString(value) {
  const hour = Math.floor(value / 3600);
  const minute = Math.floor(value / 60) % 60;
  const second = Math.round(value % 60);
  if (hour >= 1) {
    return `${hour}h ${minute}m ${second}s`;
  }
  if (minute >= 1) {
    return `${minute}m ${second}s`;
  }
  return `${second}s`;
}

export function getNumberWithOrdinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function thousand(value, fixed = 0) {
  value = Number(value);
  return value.toLocaleString("en-US", { minimumFractionDigits: fixed, maximumFractionDigits: fixed });
}

export function leadingZero(number) {
  return number < 10 ? "0" + number : number;
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getDateStr(value, defaultStr) {
  if (!defaultStr) {
    defaultStr = "yyyy-MM-dd HH:mm:ss";
  }

  return format(value, defaultStr);
}
export function replceDateT(dateStr) {
  const _dateStr = dateStr.replace("T", " ");
  return _dateStr;
}
export function numberWithCommas(value) {
  if (!isNaN(Number(value))) {
    return Number(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
export function deleteCommas(value){
  const split = value.split(',');
  let returnVal = "";
  for(const item of split){
    returnVal+=item
  }
  if(isNaN(returnVal)){
    return null
  }else{
    return Number(returnVal);
  }
}
export function getSubDaysDate(value, days) {
  return subDays(value, days);
}

export function timeConverter_seconds(seconds) {
  let timeType = "";
  if (seconds >= 60) {
    timeType = "minutes";
  } else if (seconds >= 3600) {
    timeType = "hours";
  } else {
    timeType = "seconds";
  }

  let converTime = "";
  let HH = ""
  let MM = ""
  let SS = ""
  switch (timeType) {
    case "seconds":
      converTime = "";
      break;
    case "minutes":
      MM = Math.floor(seconds / 60);
      SS = seconds - MM * 60;
      console.log(MM);
      console.log(SS);
      converTime = `00:${MM}:${SS}`;
      break;
    case "hours":
      HH = Math.floor(seconds / 3600);
      MM = Math.floor(seconds / 60);
      SS = seconds - MM * 60;
      console.log(HH);
      console.log(MM);
      console.log(SS);
      converTime = `${HH}:${MM}:${SS}`;
      break;
  }

  return converTime;
}

export function jsonSort(item, ord, type){
  let _type = "asc"
  if(type){
    _type = type
  }
  item.sort((a,b)=>{
    if(_type==="asc"){
      return Number(a[ord])-Number(b[ord])
    }else if(_type==="desc"){
      return Number(b[ord])-Number(a[ord])
    }
  })
  return item;
}
